const routes = [
    {
        path: "/document-storage",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    },
];

export default routes;
